import React from 'react';
import styles from './Footer.module.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.copyright}>
            © {currentYear} Tourzone Help Center
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 